import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DeletionCancel() {
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [state, setState] = useState({ loading: false, done: false, error: "" });

  useEffect(() => {
    // Auto-fire cancellation on load — the token in the URL IS the authorization.
    if (!token) {
      setState({ loading: false, done: false, error: "Missing cancellation token." });
      return;
    }
    (async () => {
      setState({ loading: true, done: false, error: "" });
      try {
        await axios.post(`${API}/account/delete/cancel`, { token });
        setState({ loading: false, done: true, error: "" });
      } catch (e) {
        setState({
          loading: false, done: false,
          error: e?.response?.data?.detail || "Cancellation failed. The token may have expired.",
        });
      }
    })();
  }, [token]);

  return (
    <div style={{
      minHeight: "100vh", background: "#F7F1E5", color: "#1F2A44",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 40, fontFamily: 'Georgia, "Iowan Old Style", serif',
    }} data-testid="deletion-cancel-page">
      <div style={{
        background: "#fff", padding: "40px 44px", borderRadius: 12,
        maxWidth: 520, textAlign: "center", boxShadow: "0 8px 30px rgba(31,42,68,0.09)",
      }}>
        <div style={{ fontSize: 12, letterSpacing: 2, textTransform: "uppercase",
                      color: "#B08A4A", marginBottom: 12 }}>Data &amp; Privacy</div>
        <h1 style={{ fontSize: 28, margin: "0 0 16px" }}>Cancel Account Deletion</h1>
        {state.loading && <p>Restoring your account…</p>}
        {state.done && (
          <>
            <p style={{ fontSize: 16, lineHeight: 1.6 }}>
              Your account deletion has been cancelled. Your data is restored and you can log in again immediately.
            </p>
            <Link to="/login" data-testid="deletion-cancel-login-link" style={{
              display: "inline-block", marginTop: 20, padding: "10px 22px",
              background: "#1F2A44", color: "#F7F1E5", borderRadius: 8, textDecoration: "none",
              fontFamily: "Inter, system-ui, sans-serif", fontSize: 14, fontWeight: 500,
            }}>Log in</Link>
          </>
        )}
        {state.error && (
          <>
            <p style={{ color: "#9b1c1c", lineHeight: 1.6 }} data-testid="deletion-cancel-error">{state.error}</p>
            <p style={{ fontSize: 13, color: "#6b6f7c", marginTop: 20 }}>
              If you believe this is a mistake, please contact support.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
